import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import Slide from '@material-ui/core/Slide';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core';
import Guest from './Guest';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide ref={ref} direction="up" {...props} />;
});

const useStyles = makeStyles((theme) => ({
  container: {
    backdropFilter: 'blur(5px)'
  },
  meeting: {
    color: '#19CAFF',
    fontWeight: 'bold',
    fontSize: 12
  },
  closeButton: {
    textAlign: 'right',
    cursor: 'pointer'
  },
  title: {
    fontSize: 32,
    marginBottom: 20
  },
  header: {
    textAlign: 'left'
  },
  date: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 25
  },
  address: {
    color: '#002380',
    fontSize: 16
  },
  videoLink: {
    fontSize: 14,
    color: '#002380',
    textDecoration: 'underline'
  },
  numOfGuests: {
    color: '#5F5F5F',
    fontSize: 13
  },

  infos: {
    textAlign: 'left'
  },
  paper: {
    padding: 30,
    minWidth: 700
  },
  guestsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '75%'
  },
  guests: {
    marginTop: 25
  },
  buttonDiv: {
    marginTop: 5,
    display: 'flex',
    alignItems: 'center'
  },

  send: {
    fontFamily: 'PT sans',
    fontSize: '16px',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderRadius: 0,
    minWidth: '110px'
  },
  cancel: {
    background: '#6D7278',
    fontFamily: 'PT sans',
    fontSize: '16px',
    color: '#FFF',
    textTransform: 'lowercase',
    fontWeight: 'bold',
    borderRadius: 0,
    marginRight: 15,
    minWidth: '110px'
  },
  participate: {
    fontSize: 14,
    marginTop: 25
  }
}));

const MeetingModal = ({ open, onClose }) => {
  const classes = useStyles();
  return (
    <div>
      <Dialog
        classes={{ paper: classes.paper, container: classes.container }}
        keepMounted
        maxWidth={false}
        onClose={onClose}
        open={open}
        TransitionComponent={Transition}>
        <div className={classes.closeButton}>
          <CloseIcon onClick={onClose} />
        </div>
        {/* Header */}
        <div className={classes.header}>
          <Typography className={classes.meeting} gutterBottom variant="h4">
            MEETING WITH INVESTORS
          </Typography>
          <Typography className={classes.title} gutterBottom variant="h3">
            Management presentation with BlackRock
          </Typography>
        </div>

        <div className={classes.infos}>
          <Typography className={classes.date} gutterBottom variant="h6">
            April 04 - 10h00 12h00
          </Typography>
          <Typography
            className={classes.address}
            gutterBottom
            variant="subtitle1">
            <LocationOnOutlinedIcon fontSize="small" /> 16-18 rue du Quatre
            Septembre - 75002 PARIS
          </Typography>
          <a className={classes.videoLink} href="!#">
            Join the videoconference with this link
          </a>
        </div>
        <div className={classes.guests}>
          <Typography className={classes.numOfGuests} variant="h6">
            4 guests
          </Typography>
          <div className={classes.guestsContainer}>
            <Guest />
            <Guest />
          </div>
          <div className={classes.guestsContainer}>
            <Guest />
            <Guest />
          </div>
        </div>
        <Typography
          className={classes.participate}
          gutterBottom
          variant="body1">
          Are you going to participate in this event?
        </Typography>
        <div className={classes.buttonDiv}>
          <div>
            <Button
              className={classes.cancel}
              onClick={onClose}
              variant="contained">
              no
            </Button>
          </div>
          <div>
            <Button
              className={classes.send}
              color="primary"
              onClick={onClose}
              variant="contained">
              yes
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default MeetingModal;
